import { render, staticRenderFns } from "./WithdrawalBill.vue?vue&type=template&id=961d54b2&scoped=true&"
import script from "./WithdrawalBill.vue?vue&type=script&lang=js&"
export * from "./WithdrawalBill.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalBill.vue?vue&type=style&index=0&id=961d54b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961d54b2",
  null
  
)

export default component.exports